import App from "@frog/source/models/App.js"
import Stage from "@frog/source/models/Stage.js"
import Step from "@frog/source/models/Step.js"

export default function CarryOn(stage) {
    const step = App.sequence.steps.shift()
    if(step.followingProtosteps == undefined) {
        return
    }
    if(step.followingProtosteps.length == 0) {
        step.followingProtosteps = [Step.instantiate({"alphastage": stage})]
    }
    App.sequence = {
        "steps": Stage.processEventSteps(Stage.copy(stage), step.followingProtosteps)
    }
    if(App?.game?.chapter?.stage != undefined
    && App.sequence.steps != undefined
    && App.sequence.steps.length > 0
    && App.sequence.steps[App.sequence.steps?.length - 1]?.omegastage != undefined) {
        App.game.chapter.stage = App.sequence.steps[App.sequence.steps.length - 1].omegastage
    }
}
